import formatDate from 'date-fns/format';
import { DatePicker } from 'tombac';
import { useUserDateFormat } from "./useFormatUserDate";
import { jsx as _jsx } from "react/jsx-runtime";
const parseDate = (inputValue, dateFormat) => inputValue && inputValue instanceof Date ? formatDate(new Date(inputValue.getUTCFullYear(), inputValue.getUTCMonth(), inputValue.getUTCDate()), dateFormat) : '';
export const AppDatePicker = props => {
  const dateFormat = useUserDateFormat();
  return /*#__PURE__*/_jsx(DatePicker, {
    $minWidth: "145px",
    dateFormat: dateFormat,
    onBlur: props.onBlur ?? (() => {}),
    parseValue: parseDate,
    ...props,
    "data-sentry-element": "DatePicker",
    "data-sentry-component": "AppDatePicker",
    "data-sentry-source-file": "AppDatePicker.tsx"
  });
};